import { useSelector, useDispatch } from 'react-redux';
import Button from '@mui/material/Button';

import {
  Add as AddIcon
} from '@mui/icons-material';

import classes from './classes.module.scss';
import FilterOperatorToggle from './FilterOperatorToggle';

import {
  addFilter,
  setFilterOperator
} from 'app/actions/filters';

import {
  AND_OPERATOR
} from 'app/hooks/useFilter';

const FilterStack = props => {
  const {
    // filterParams passed by AgGrid
    filterParams: {
      colDef: {
        field,
        floatingFilterComponentParams: {
          resource
        }
      }
    },
    FilterComponent,
    filterClass,
    defaultFilterType
  } = props;

  const reduxParams = useSelector(state => state.params[resource]);
  const dispatch = useDispatch();

  // throw error if filter params not setup in Redux
  if (!reduxParams) {
    throw `This resource needs to be added to the paramsReducers file: ${resource}`;
  }

  const filterModel = reduxParams.filter_model;
  const filterCount = filterModel[field]?.length || 1;

  const onAddFilterClick = () => {
    dispatch(addFilter({ resource, field, filterClass, filterType: defaultFilterType }));
  }

  const renderFilter = filterIndex => {
    let operator = (
      filterModel[field] &&
      filterModel[field][filterIndex] &&
      filterModel[field][filterIndex].operator
    ) || AND_OPERATOR;

    // only show AND / OR toggle for subsequent filters
    let operatorToggle = null;
    if (filterIndex > 0) {
      const onChange = value => {
        dispatch(setFilterOperator({ resource, field, filterIndex, operator: value }));
      }

      operatorToggle = (
        <div className={classes.filterStackOperatorToggle}>
          <FilterOperatorToggle
            defaultValue={operator}
            onChange={onChange}
            sx={{
              display: 'inline-flex',
              flexDirection: 'row',
              justifyContent: 'left',
              margin: '0.2rem 0.2rem 0 0'
            }}
          />
        </div>
      )
    }

    let key = 'filter-' + filterIndex;

    let sx = {
      width: '100%'
    }

    let style = {};
    if (filterIndex > 0) {
      style.width = 'calc(100% - 57px)';
    }

    return (
      <div key={key} className={classes.filterStack}>
        {operatorToggle}
	<div className={classes.filterComponent} style={style}>
	  <FilterComponent {...{ ...props, filterIndex, sx }} />
	</div>
      </div>
    );
  }

  let filters = [];
  for (let i = 0; i < filterCount; i++) {
    filters.push(renderFilter(i));
  }

  // only show Add Filter if the most recent filter has been set (isn't empty)
  let addFilterBtn = null;
  let lastFilterIndex = filterCount - 1;
  let lastFilterValue = filterModel[field] && filterModel[field][lastFilterIndex]?.value;
  let showAddFilter = lastFilterValue !== undefined;

  if (showAddFilter) {
    let addFilterSx = {
      padding: '4px 0',
      color: '#000 !important'
    }

    addFilterBtn = (
      <div className={classes.addFilterButton}>
        <Button type="text" sx={addFilterSx} onClick={onAddFilterClick}><AddIcon /><span className={classes.addFilterButtonLabel}>Add Filter</span></Button>
      </div>
    );
  }

  return (
    <div>
      {filters}
      {addFilterBtn}
    </div>
  );
}

export default FilterStack;
